"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spotlight = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.Spotlight = {
  name: 'Spotlight',
  form: {
    modal: {
      maxWidth: "800px"
    },
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      organisations: {
        type: 'linkedMultiple',
        entityTypeName: 'Organisation',
        description: 'Which {{ORGANISATIONS}} should be spotlighted?'
      },
      people: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        description: 'Which {{PEOPLE}} should be spotlighted?'
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'SpotlightType'
      },
      priority: {
        type: 'int',
        description: 'Set a priority number for this {{SPOTLIGHT}}, with lowest being first, to allow items to be sorted in listings. Lowest numbers will be shown first, and any items withno Spotlights will be assumed to have high numbers, and therefore be displayed last.'
      },
      description: {
        type: 'longText'
      },
      color: {
        type: 'linked',
        entityTypeName: 'Color'
      }
    })
  },
  table: {
    fieldNames: ['types', 'priority', 'organisations', 'people'],
    fields: {
      types: {
        weight: 1.5,
        title: 'Types'
      },
      priority: {
        weight: 1
      },
      people: {
        weight: 2
      },
      organisations: {
        weight: 2
      }
    }
  }
};